import { useAccountBadgeTable } from '../../../../../ui/features/badge-management/hooks/useAccountBadgeTable';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { ChipMenu } from '@juvare/alert-ui/ui/features/alerts/components/AlertsList/components/ChipMenu';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box } from '@mui/material';
import React from 'react';
import { AccountBadgeUserViewTableContent } from './AccountBadgeUserViewTableContent';
export const AccountBadgeUserViewTable = (props) => {
    const { t } = useBadgingTranslation();
    const [validFirst, setValidFirst] = React.useState(true);
    const { dataTableProps, reload } = useAccountBadgeTable({
        initialFilter: [
            {
                op: '=',
                column: 'accountId',
                value: props.accountId,
            },
        ],
        useDataTableParamOverrides: {
            defaultSortColumnKey: 'isStatusValid',
            defaultSortColumnDesc: validFirst,
            defaultRowsPerPage: 10,
        },
        dataTablePropResultOverrides: () => ({
            title: t('accountBadgeSection.accountBadgesTable.tableTitle'),
            filtersBar: undefined,
            rowSelectionEnabled: false,
            onRowClick: undefined,
            customHeaderElement: (React.createElement(Box, { sx: {
                    display: 'inline-block',
                    backgroundColor: themeColors.surface.primary,
                    overflow: 'hidden',
                } },
                React.createElement(ChipMenu, { label: validFirst
                        ? t('accountBadgeSection.accountBadgesTable.sortValidFirst')
                        : t('accountBadgeSection.accountBadgesTable.sortInvalidFirst'), menuItems: [
                        {
                            label: t('accountBadgeSection.accountBadgesTable.sortValidFirst'),
                            onClick: () => setValidFirst(true),
                        },
                        {
                            label: t('accountBadgeSection.accountBadgesTable.sortInvalidFirst'),
                            onClick: () => setValidFirst(false),
                        },
                    ] }))),
        }),
    });
    const handleActionSuccess = () => Promise.resolve().then(reload);
    return (React.createElement(Box, null,
        React.createElement(DataTable, Object.assign({ tableSx: { tableLayout: 'fixed' } }, dataTableProps, { customTableSurfaceComponent: AccountBadgeUserPerspectiveTableSurface, customTableContentComponent: (tableContentProps) => (React.createElement(AccountBadgeUserViewTableContent, Object.assign({}, tableContentProps, { reload: reload, onActionSuccess: handleActionSuccess, AccountBadgeSlideoutComponent: props.AccountBadgeSlideoutComponent }))) }))));
};
const AccountBadgeUserPerspectiveTableSurface = ({ children }) => {
    return React.createElement(Box, { sx: { backgroundColor: 'transparent' } }, children);
};
